import MailgunMessages from '../../pages/mailgun/Messages';
import MailgunMessage from '../../pages/mailgun/Message';
import ShowMailgunMessage from '../../pages/mailgun/ShowMessage';
import {authGuard} from '../guards';

function getRoutes(routePrefix, layout) {

  let basePath = (routePrefix === 'library')
    ? '/v2/app/content/mailgun'
    : '/v2/mobile/mailgun'

  return [
    {
      path: `${basePath}/messages`,
      name: `${routePrefix}.mailgun.messages`,
      component: MailgunMessages,
      meta: {
        layout: layout,
        allow_restricted_user: true, // MLD-2750
      },
    },
    {
      path: `${basePath}/messages/:messageID(\\d+)`,
      component: MailgunMessage,
      children: [
        {
          path: ``,
          name: `${routePrefix}.mailgun.message`,
          component: ShowMailgunMessage,
          meta: {
            layout: layout,
            allow_restricted_user: true, // MLD-2750
          },
        }
      ],
    },
  ]
}

export default [
  ...authGuard([
    ...getRoutes('library', 'content'),
    ...getRoutes('mobile', 'mobile'),
  ]),
]
